<template>
  <div class="component-center">
    <div class="after-create-wrapper">
      <img
        src="https://res.cloudinary.com/webalys/image/private/w_800,h_800,ar_1/f_auto/v1/icons/illustrations-brooklyn/work/work/approval-2-eemhg0gix2s2iqyycd9goh.png"
        alt="notice-image"
      />
      <p class="notice-static">{{ $t('PEER.FinishNotice.explanation1') }}</p>
      <p class="notice-warning">{{ $t('PEER.FinishNotice.explanation2') }}</p>
    </div>
    <div class="button-wrapper">
      <button @click="downloadLinkFile">{{ $t('PEER.FinishNotice.download') }}</button>
      <button @click="() => $router.push('/peer/evaluation')">
        {{ $t('PEER.FinishNotice.goToMain') }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { fileDownloadPeer } from '@/modules/fileController';

export default {
  name: 'FinishNotice',
  computed: {
    ...mapState('peerPaper', ['downloadableData']),
  },
  methods: {
    downloadLinkFile() {
      fileDownloadPeer(this.downloadableData);
    },
  },
};
</script>

<style lang="scss" scoped>
.after-create-wrapper {
  text-align: center;

  img {
    width: 200px;
    margin: 30px;
  }
}
.notice-static {
  font-weight: bold;
  font-size: 1.2rem;
}
.notice-warning {
  font-weight: 400;
  font-size: 1rem;
  color: red;
}
.button-wrapper {
  justify-content: center;
}
</style>
